import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

const PADDING = {
  md: 'p-5',
  sm: 'p-4',
  none: '',
} as const

/** White working surface with a hairline border — structure without shadow. */
export function Card({
  padding = 'md',
  className,
  children,
}: {
  padding?: keyof typeof PADDING
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn('rounded-md border border-rule bg-card', PADDING[padding], className)}>
      {children}
    </div>
  )
}
